import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"

const world = Tiled.parse({
    "tilemap": require("./tiles.json"),
    "tileset": require("@frog/source/data/levels/vmenezio.tileset.json"),
})
world.spots = require("./spots.json")

export default {
    "slug": "y5",
    "stage": {
        "image": require("./tiles.png"),
        "units": require("./units.json"),
        "world": world,
        "text": "Assassinate the warlord",
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    PlotSteps.PlayAudio("Music:Combat"),
                    PlotSteps.SpawnPlayerPartyScript(),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return stage.currentEncounterKey == 1
                        && PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": "bad"})
                },
                "events": [
                    PlotSteps.HealPlayerPartyScript(),
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": 2})
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return stage.currentEncounterKey == 2
                        && stage.units["warlord"].isDead == true
                },
                "events": [
                    PlotSteps.ChapterSuccessClassic(),
                    {"func": () => Navigation.go("/games/war")},
                ]
            },
            PlotScripts.ChapterFailure(),
        ]
    },
}
